/**
 * Runtime configuration. Values are public client identifiers (Cognito pool /
 * app-client IDs and the API origin all ship in the browser bundle anyway), so
 * the production defaults are baked in and can be overridden per-environment
 * with Vite `VITE_*` env vars at build time.
 *
 * Sourced from PulseFoundationStack + PulseApiStack CloudFormation outputs.
 */
const env = import.meta.env;

export const config = {
  region: env.VITE_AWS_REGION ?? 'us-east-1',
  userPoolId: env.VITE_USER_POOL_ID ?? 'us-east-1_L4gdk17KN',
  userPoolClientId: env.VITE_USER_POOL_CLIENT_ID ?? 'ffbomsdsb8tem6u33ffj0a3ku',
  apiBaseUrl: (env.VITE_API_BASE_URL ?? 'https://api.chamberpulse.io').replace(/\/$/, ''),
  // pulse-payments Lambda Function URL (public; hosted Join-the-Chamber checkout).
  paymentsUrl: (env.VITE_PAYMENTS_URL ?? 'https://bjzkudp2lzzlxnaqi4chwawxie0jowps.lambda-url.us-east-1.on.aws').replace(/\/$/, ''),
  // pulse-mcp Lambda Function URL (Claude Desktop add-on endpoint).
  mcpUrl: (env.VITE_MCP_URL ?? 'https://dpuhdjh5mvngcabawxhnftsdea0wsaog.lambda-url.us-east-1.on.aws').replace(/\/$/, ''),
} as const;
